import { render } from "./Logout.vue?vue&type=template&id=faf9920e&scoped=true"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"

import "./Logout.vue?vue&type=style&index=0&id=faf9920e&scoped=true&lang=css"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faf9920e"]])

export default __exports__